import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import WhoWeAre from './components/WhoWeAre';
import Values from './components/Values';
import Services from './components/Services';
import Sectors from './components/Sectors';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './styles/App.css';

function App() {
  const [language, setLanguage] = useState('fr');

  useEffect(() => {
    document.body.classList.toggle('fr', language === 'fr');
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'fr' : 'en');
  };

  return (
    <div className="App">
      <Navbar 
        language={language}
        onToggleLanguage={toggleLanguage}
      />
      <Hero language={language} />
      <About language={language} />
      <WhoWeAre language={language} />
      <Values language={language} />
      <Services language={language} /> {/* Contient maintenant Plateformes + Services */}
      <Sectors language={language} />
      <Contact language={language} />
      <Footer language={language} />
    </div>
  );
}

export default App;
